import React, {Component} from  'react';
import Game from './GameTable/Game';



class MainInfo extends Component {
    state = {
        count:0,
        timer:0,
        initGame: false,
        updateGameTable: false
    }

    shouldComponentUpdate(){
        return this.state.initGame;
    }

    logToConsole = (e)=> {
        if (e.target.className === 'Element' && this.state.initGame) {
            this.setState((state)=>{
                return {count: state.count + 1}
             });
             e.target.className = 'Element-empty';
            console.log(e.target.className)
        }
    }


    
    timerUpdated(){  this.setState((state)=>{
        return {timer: state.timer + 1}
     }); }

    
    initGameHandler =()=>{
        this.setState({initGame: true})
       console.log('refreshHandler')
       clearInterval(this.timerID)
       this.timerID=setInterval(() => {  this.timerUpdated() }, 1000);
       this.setState(()=>{
        return {timer:0 , count:0,updateGameTable: false}


     }); 
    }

    finishGameHandler = (score)=>{
        console.log(score)
        if(this.state.count === score-1) {
            alert('-----GAME OVER-----'+
            'YOUR TIME: '+this.state.timer+' seconds'+
            ' YOUR COUNT: '+(this.state.count+1)+' points');
            clearInterval(this.timerID)
            this.setState({initGame: true,updateGameTable: true})
        }

     }

render(){

    return(
        <div>
        <p>Timer : <strong>{this.state.timer} seconds </strong></p>
        <p>Counter :<strong>{this.state.count}</strong></p>
        <button onClick={this.initGameHandler}>START GAME</button>
        <Game click={this.logToConsole} updateData={this.finishGameHandler} updatehandler={this.state.updateGameTable}/>
    </div>
    )
}
 }
   
   
export default MainInfo;

